/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FitAndProperCheckViewModel } from './FitAndProperCheckViewModel';
import {
    FitAndProperCheckViewModelFromJSON,
    FitAndProperCheckViewModelFromJSONTyped,
    FitAndProperCheckViewModelToJSON,
} from './FitAndProperCheckViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfFitAndProperCheckViewModel
 */
export interface ResultOfFitAndProperCheckViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfFitAndProperCheckViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfFitAndProperCheckViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfFitAndProperCheckViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfFitAndProperCheckViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfFitAndProperCheckViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfFitAndProperCheckViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfFitAndProperCheckViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {FitAndProperCheckViewModel}
     * @memberof ResultOfFitAndProperCheckViewModel
     */
    data?: FitAndProperCheckViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfFitAndProperCheckViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfFitAndProperCheckViewModel interface.
 */
export function instanceOfResultOfFitAndProperCheckViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfFitAndProperCheckViewModelFromJSON(json: any): ResultOfFitAndProperCheckViewModel {
    return ResultOfFitAndProperCheckViewModelFromJSONTyped(json, false);
}

export function ResultOfFitAndProperCheckViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfFitAndProperCheckViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : FitAndProperCheckViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfFitAndProperCheckViewModelToJSON(value?: ResultOfFitAndProperCheckViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': FitAndProperCheckViewModelToJSON(value.data),
        'Count': value.count,
    };
}

